"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeliveryIcon = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const Bpost_1 = __importDefault(require("@kawaui/icons/build/icons/delivery/Bpost"));
const MondialRelay_1 = __importDefault(require("@kawaui/icons/build/icons/delivery/MondialRelay"));
const PostNl_1 = __importDefault(require("@kawaui/icons/build/icons/delivery/PostNl"));
const react_1 = require("react");
exports.DeliveryIcon = (0, react_1.memo)(function DeliveryIcon({ name }) {
    const iconSize = '50';
    switch (name.toLowerCase()) {
        case 'bpost':
            return (0, jsx_runtime_1.jsx)(Bpost_1.default, { height: iconSize, width: iconSize });
        case 'mondial_relay':
            return (0, jsx_runtime_1.jsx)(MondialRelay_1.default, { height: iconSize, width: iconSize });
        case 'post_nl':
            return (0, jsx_runtime_1.jsx)(PostNl_1.default, { height: iconSize, width: iconSize });
        default:
            return null;
    }
});
exports.default = exports.DeliveryIcon;
